import { useIntl } from 'react-intl';
import { Stack } from '@mui/material';

import AgTypography from '../../stories/Styles/AgTypography';

const Confirmation = () => {
  const messages = useIntl().formatMessage;

  return (
    <Stack gap={2} minHeight={200}>
      <AgTypography contentStyle='AP.Paragraph.Large.Regular'>
        {messages({ id: 'CONSENT_MODAL_BODY_1' })}
      </AgTypography>

      <AgTypography contentStyle='AP.Paragraph.Large.Regular'>
        {messages({ id: 'CONSENT_MODAL_BODY_2' })}
      </AgTypography>
    </Stack>
  );
};

export default Confirmation;